import axios from '@/js/helper/axios-helper.js'
import { get, isUndefined, isEmpty } from 'lodash-es'

import API_CONSTANTS from '@/js/helper/api-constants.js'

// import { makeQuerablePromise } from '@/js/helper/promise-helper'

import { getBrandById } from './helper'

import CONST from './brands-constants'
import ACTION_TYPES from './actions-types'
import MUTATION_TYPES from './mutation-types'

export default {
  [ACTION_TYPES.SET_BRANDS]: async ({ commit }, brands) => {
    brands.forEach(brand => {
      commit(MUTATION_TYPES.SET_BRAND, {
        id: brand.id,
        brand: get(brand, API_CONSTANTS.ATTRIBUTES, {}),
      })
    })
  },
  [ACTION_TYPES.LOAD_BRAND_LOGO]: async ({ state, commit }, brand) => {
    const storedBrand = getBrandById(state, brand)
    if (isUndefined(storedBrand)) {
      return
    }

    const isRequested = get(storedBrand, CONST.LOGO_PROMISE)
    if (isRequested) {
      return Promise.resolve()
    }

    // const storedLogoData = get(storedBrand, CONST.LOGO_DATA)
    // if (!isUndefined(storedLogoData)) {
    //   return Promise.resolve()
    // }

    const brandId = get(storedBrand, CONST.ID)
    commit('SET_BRAND_PROMISE', { brand: brandId, promise: true })

    const storedLogoUrl = get(storedBrand, CONST.LOGO_URL)
    if (isUndefined(storedLogoUrl) || isEmpty(storedLogoUrl)) {
      return Promise.resolve()
    }

    const promise = axios
      .get(storedLogoUrl)
      .then(response => {
        commit('SET_BRAND_LOGO', { brand: brandId, data: response.data })
      })
      .catch(error => {
        const status = get(error, 'response.status', 400)

        if (status > 500) {
          commit('SET_BRAND_LOGO', { brand: brandId, data: undefined })
        }
      })

    // const storedLogoPromise = get(storedBrand, CONST.LOGO_PROMISE)
    // if (!isUndefined(storedLogoPromise)) {
    //   if (storedLogoPromise.isRejected() && isUndefined(storedLogoData)) {
    //     return
    //   }

    //   if (storedLogoPromise.isPending() || storedLogoPromise.isFulfilled()) {
    //     return storedLogoPromise
    //   }
    // }

    // const promise = makeQuerablePromise(
    //   axios
    //     .get(storedLogoUrl)
    //     .then(response => {
    //       commit('SET_BRAND_LOGO', { brand: brandId, data: response.data })
    //       commit('SET_BRAND_PROMISE', { brand: brandId, promise: undefined })
    //     })
    //     .catch(error => {
    //       const status = get(error, 'response.status', 400)

    //       if (status > 500) {
    //         commit('SET_BRAND_LOGO', { brand: brandId, data: undefined })
    //       }

    //       commit('SET_BRAND_PROMISE', { brand: brandId, promise: undefined })
    //     }),
    // )

    // commit('SET_BRAND_PROMISE', { brand, promise })

    return promise
  },
}
